import { useState } from 'react';
import type { EventItem } from '@/mocks/events';
import { eventImgs } from '@/mocks/images';
import { ProgressBadge } from './Atoms';

export default function EventCard({ item }: { item: EventItem }) {
  const [open, setOpen] = useState(false);

  return (
    <article className="flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300">
      <div className="relative">
        <img
          src={eventImgs[item.slug] ?? eventImgs['video-72-hours']}
          alt={`${item.title} 配图`}
          className="h-44 w-full object-cover object-top md:h-48"
        />
        <div className="absolute left-3 top-3">
          <ProgressBadge label={item.progress} />
        </div>
        <span className="absolute right-3 top-3 inline-flex items-center rounded-full bg-background-50/90 px-2 py-1 text-xs font-medium text-foreground-700">
          {item.kicker}
        </span>
      </div>

      <div className="flex flex-1 flex-col p-4 md:p-5">
        <h3 className="text-base font-bold leading-snug text-foreground-950 md:text-lg">{item.title}</h3>
        <p className="mt-2 flex-1 text-sm leading-6 text-foreground-600">{item.summary}</p>

        <div className="mt-3 flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-foreground-500">
          <span className="flex items-center gap-1 whitespace-nowrap">
            <i className="ri-calendar-line" aria-hidden="true" />
            {item.date}
          </span>
          <span className="flex items-center gap-1 whitespace-nowrap">
            <i className="ri-time-line" aria-hidden="true" />
            阅读 {item.readMinutes} 分钟
          </span>
          <span className="flex items-center gap-1 whitespace-nowrap">
            <i className="ri-message-3-line" aria-hidden="true" />
            {item.replies.toLocaleString()} 条讨论
          </span>
        </div>

        <div className="mt-3 flex flex-wrap gap-2">
          {item.tags.map((t) => (
            <span
              key={t}
              className="inline-flex items-center whitespace-nowrap rounded-full bg-secondary-100 px-2.5 py-1 text-xs text-secondary-800"
            >
              #{t}
            </span>
          ))}
        </div>

        <div className="mt-4 border-t border-background-200 pt-3">
          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            className="inline-flex items-center gap-1 text-sm font-medium text-primary-600 transition-colors hover:text-primary-700"
            aria-expanded={open}
          >
            {open ? '收起要点' : '展开复盘要点'}
            <i className={`text-sm transition-transform ${open ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'}`} aria-hidden="true" />
          </button>
          {open && (
            <ul className="mt-3 space-y-2">
              {item.briefs.map((b) => (
                <li key={b} className="flex gap-2 text-sm leading-6 text-foreground-700">
                  <i className="mt-1 text-accent-500 ri-checkbox-blank-circle-fill text-[6px]" aria-hidden="true" />
                  {b}
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </article>
  );
}